module.exports = __webpack_public_path__ + "img/Umetrip.6eba4cfc.png";